/**
 * Created by r4zi4l on 17.12.2021
 */

const Draggable = function (unit) { 
    UnitComponent.call(this, unit);
};

Draggable.prototype = Object.create(UnitComponent.prototype);
Draggable.prototype.constructor = Draggable;

Draggable.prototype.onDragStart = function () {
    if (this.view) {
        this.view.handleDragStart();
    }
};

Draggable.prototype.onDragEnd = function () {
    if (this.view) {
        this.view.handleDragEnd();
    }
};

Draggable.prototype.onCanBeAccepted = function (accepted) {
    if (this.view) {
        this.view.canBeAccepted(accepted);
    } 
};

Draggable.prototype.handleDragStart = function () {
    this.acceptors = [];

    Draggable.REGISTERED_ALGORITHMS
        .forEach((algo) => this.acceptors.push(...algo.listAcceptors(this.unit)));

    this.acceptors.forEach((acceptor) => acceptor.highlightDragTarget());

    this.onDragStart();
};

Draggable.prototype.handleDragMove = function (x, y) {
    let acceptor;
    Draggable.REGISTERED_ALGORITHMS.find((algo) => {
        acceptor = algo.findAcceptor(this.unit, { x, y });
        return acceptor;
    });

    if (acceptor) {
        if (this.unit.light) {
            this.unit.light.hide();
        }
        this.unit.onMarkNormal();
        this.onCanBeAccepted(true);
        return true;
    }

    this.acceptors.forEach((acceptor) => {
        acceptor.highlightDragTarget();
    });

    this.onCanBeAccepted(false);
};

Draggable.prototype.handleDragEnd = function (x, y) {
    if (this.acceptors) {
        this.acceptors.forEach((acceptor) => acceptor.unhighlightDragTarget());
        this.acceptors = undefined;
    }

    let acceptor;
    Draggable.REGISTERED_ALGORITHMS.find((algo) => {
        acceptor = algo.findAcceptor(this.unit, { x, y }, true);
        return acceptor;
    });

    this.onDragEnd();

    if (acceptor) {
        acceptor.acceptDraggable(this.unit);
        return true;
    }
};

Draggable.REGISTERED_ALGORITHMS = [];

Draggable.registerAlgorithm = function (algo) {
    Draggable.REGISTERED_ALGORITHMS.push(algo);
    Draggable.REGISTERED_ALGORITHMS.sort((a, b) => a.priority - b.priority);
};